export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categoryColor: string;
  image: string;
  alt: string;
  readTime: string;
  date: string;
  author: string;
  featured?: boolean;
}

export const BLOG_POSTS: BlogPost[] = [
{
  id: 'blog-1',
  title: 'The Ultimate Guide to Exploring the Sahara in 7 Days',
  excerpt: 'From Tamanrasset to the Tassili N\'Ajjer plateau — a complete itinerary for first-time desert travelers, including the best camps and hidden oases.',
  category: 'Travel Guide',
  categoryColor: 'bg-primary-500',
  image: "https://images.unsplash.com/photo-1549998713-4b124b07197d",
  alt: 'Golden Saharan sand dunes stretching to the horizon at sunset with dramatic shadows',
  readTime: '8 min read',
  date: 'Apr 14, 2026',
  author: 'Karim Benali',
  featured: true
},
{
  id: 'blog-2',
  title: 'Algiers in 48 Hours: The Casbah, the Sea & the Best Couscous',
  excerpt: 'A tight weekend itinerary through the UNESCO-listed Casbah, the Martyrs\' Memorial, and the hidden rooftop restaurants locals actually eat at.',
  category: 'City Break',
  categoryColor: 'bg-accent-500',
  image: "https://images.unsplash.com/photo-1671222842347-d43c51c17bb8",
  alt: 'Algiers white buildings cascading down to the Mediterranean sea at golden hour',
  readTime: '5 min read',
  date: 'Apr 9, 2026',
  author: 'Yasmine Cherif'
},
{
  id: 'blog-3',
  title: 'Constantine\'s Hanging Bridges: A Photographer\'s Dream',
  excerpt: 'Why Constantine is Algeria\'s most dramatic city — and the exact spots to capture the gorges, the Sidi M\'Cid bridge, and the old medina at blue hour.',
  category: 'Photography',
  categoryColor: 'bg-sand-300',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13033a45a-1776710537001.png",
  alt: 'Constantine ancient city perched on dramatic rocky gorges with suspension bridges at dusk',
  readTime: '6 min read',
  date: 'Apr 3, 2026',
  author: 'Sofiane Mekki'
},
{
  id: 'blog-4',
  title: 'Oran\'s Seafront Hotels: Which One Is Actually Worth It?',
  excerpt: 'We stayed in 5 hotels along Oran\'s Corniche and ranked them honestly — from the budget-friendly to the splurge-worthy, with real photos and prices.',
  category: 'Hotel Review',
  categoryColor: 'bg-primary-500',
  image: "https://images.unsplash.com/photo-1470216610917-44af65528d9a",
  alt: 'Oran coastal city with colorful buildings and Mediterranean harbor at sunset',
  readTime: '7 min read',
  date: 'Mar 28, 2026',
  author: 'Nadia Bouzid'
},
{
  id: 'blog-5',
  title: 'Tlemcen: Algeria\'s Forgotten Jewel of Islamic Architecture',
  excerpt: 'The Great Mosque, the Mansourah ruins, and the Lalla Setti plateau — why Tlemcen deserves a spot on every serious traveler\'s Algeria itinerary.',
  category: 'Culture',
  categoryColor: 'bg-accent-500',
  image: "https://images.unsplash.com/photo-1552231665-bf285aef2a79",
  alt: 'Ornate Islamic architecture with intricate geometric tile work and arched doorways in Algeria',
  readTime: '9 min read',
  date: 'Mar 20, 2026',
  author: 'Hamza Touati'
},
{
  id: 'blog-6',
  title: 'How to Travel Algeria on 3,000 DZD a Day (Yes, Really)',
  excerpt: 'Budget hostels, street food, shared taxis, and free attractions — a practical guide to experiencing Algeria without breaking the bank.',
  category: 'Budget Travel',
  categoryColor: 'bg-sand-300',
  image: "https://images.unsplash.com/photo-1588461270608-1f4bf4eadd6b",
  alt: 'Traveler with backpack walking through a traditional Algerian market with colorful spices',
  readTime: '10 min read',
  date: 'Mar 15, 2026',
  author: 'Amira Khelil'
}];